import { createFileRoute } from '@tanstack/react-router';

import { Layout } from './-components/Layout';
import { ReleaseNotesForm } from './-components/ReleaseNotesForm';

// Bookmarks of `/releasenotes` open a new release note, as `/releasenotes/new` does
export const Route = createFileRoute('/_authenticated/releasenotes/')({
    component: () => (
        <Layout>
            <ReleaseNotesForm />
        </Layout>
    ),
});
